import(/* webpackMode: "eager" */ "/app/components/accordions/FaqFullPage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/accordions/FaqWithButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/Pricing.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/procuct/features/LeaveMSTestimonials.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/procuct/HRMSPrice.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/procuct/HrmsPricing.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/procuct/ProductTestimonials.jsx");
;
import(/* webpackMode: "eager" */ "/app/components/others/ClientSlider.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
